import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { DiscountCategory } from './discount-category.types';
import { DiscountSlab, DiscountSlabResponse, DiscountSlabsParams } from './discount-slabs.types';

export interface DiscountCategoryListParams {
  row?: number;
  fetch?: number;
  search?: string;
  q?: string;
}

export const getDiscountCategoryList =
  (client: AxiosInstance) =>
  async (params?: DiscountCategoryListParams): Promise<PaginatedApiResponse<DiscountCategory[]>> => {
    return (
      await client.get<PaginatedApiResponse<DiscountCategory[]>>(API_ROUTES.GET_DISCOUNT_CATEGORY_LIST, {
        params,
      })
    ).data;
  };

export const getDiscountCategoryDetail =
  (client: AxiosInstance) =>
  async (categoryId?: string): Promise<ApiResponse<DiscountCategory>> => {
    return (
      await client.get<ApiResponse<DiscountCategory>>(API_ROUTES.GET_DISCOUNT_CATEGORY_DETAIL, {
        params: { categoryId },
      })
    ).data;
  };

export const getDiscountCategoryDetailList =
  (client: AxiosInstance) =>
  async (params?: DiscountSlabsParams): Promise<PaginatedApiResponse<DiscountSlabResponse>> => {
    return (
      await client.get<PaginatedApiResponse<DiscountSlabResponse>>(API_ROUTES.DISCOUNT_CATEGORY_DETAIL_LIST, {
        params,
      })
    ).data;
  };

export const getDiscountCategoryDetailListDetail = (client: AxiosInstance) => async (categoryDetailId?: string) => {
  return (
    await client.get<ApiResponse<DiscountSlab>>(API_ROUTES.GET_DISCOUNT_CATEGORY_DETAIL_LIST_DETAIL, {
      params: { categoryDetailId: categoryDetailId || '' },
    })
  ).data;
};

export const discountCategoryQueries = {
  all: () => ['discountCategory'] as const,
  list: (params?: DiscountCategoryListParams) =>
    queryFactoryOptions<PaginatedApiResponse<DiscountCategory[]>>({
      queryKey: [...discountCategoryQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getDiscountCategoryList(client)(params),
    }),
  detail: (categoryId?: string) =>
    queryFactoryOptions<ApiResponse<DiscountCategory>>({
      queryKey: [...discountCategoryQueries.all(), 'detail', categoryId],
      queryFn: (client: AxiosInstance) => () => getDiscountCategoryDetail(client)(categoryId),
      enabled: Boolean(categoryId),
    }),
  detailList: (params?: DiscountSlabsParams) =>
    queryFactoryOptions<PaginatedApiResponse<DiscountSlabResponse>>({
      queryKey: [...discountCategoryQueries.all(), 'detailList', params],
      queryFn: (client: AxiosInstance) => () => getDiscountCategoryDetailList(client)(params),
    }),
  detailItem: (categoryDetailId?: string) =>
    queryFactoryOptions<ApiResponse<DiscountSlab>>({
      queryKey: [...discountCategoryQueries.all(), 'detailItem', categoryDetailId],
      queryFn: (client: AxiosInstance) => () => getDiscountCategoryDetailListDetail(client)(categoryDetailId),
    }),
};
